import { AlpineComponent } from "alpinejs";

type DownloadOrderConfirmationComponent = AlpineComponent<{
	download: (orderNumber: string, customerNumber: string) => void;
}>;

export default (): DownloadOrderConfirmationComponent => {
	return {
		async download(orderNumber: string, customerNumber: string) {
			const previewWindow = window.open("", "_blank");
			if (!previewWindow) {
				return;
			}

			const query = new URLSearchParams({ orderNumber, customerNumber });
			const response = await fetch(`/_esfn/api/Integration/orderconfirmation?${query}`);

			if (!response.ok) {
				previewWindow.close();
				return;
			}

			const pdfUrl = URL.createObjectURL(await response.blob());
			previewWindow.location.href = pdfUrl;
		},
	};
};
